import { gql } from "@apollo/client";

const LOGIN_USER = gql`
  mutation LOGIN_USER($input: LoginInput!) {
    login(input: $input) {
      authToken
      refreshToken
      user {
        id
        name
      }
    }
  }
`

export default LOGIN_USER
